import { render, staticRenderFns } from "./borrower-disbursement.vue?vue&type=template&id=2de2845c&scoped=true&"
import script from "./borrower-disbursement.vue?vue&type=script&lang=js&"
export * from "./borrower-disbursement.vue?vue&type=script&lang=js&"
import style0 from "./borrower-disbursement.vue?vue&type=style&index=0&id=2de2845c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de2845c",
  null
  
)

export default component.exports